import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TaskComponent } from './task/task.component';
import { ReportSummaryComponent } from './report-summary/report-summary.component';
import { ReportsComponent } from './reports/reports.component';
import { FederalReportsComponent } from './federal-reports/federal-reports.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { AppointmentHistoryComponent } from './appointment-history/appointment-history.component';
import { navbarRoute } from './navbar';
import { RedirectComponent } from './redirect/redirect.component';
import { innerNavRoute } from './inner-nav'
import { NonComplianceComponent } from './non-compliance/non-compliance.component';
import { PersonInformationComponent } from './person-information/person-information.component';
import { PersonSummaryComponent } from './person-summary/person-summary.component';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { RequestPaymentComponent } from './request-payment/request-payment.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NonComplianceSummaryComponent } from './non-compliance-summary/non-compliance-summary.component';
import { AdminComponent } from './admin/admin.component';
import { HouseholdSummaryComponent } from './household-summary/household-summary.component';
import { EmploymentSummaryComponent } from './employment-summary/employment-summary.component';
import { EligibilitySummaryComponent } from './eligibility-summary/eligibility-summary.component';
import { EnrollmentSummaryComponent } from './enrollment-summary/enrollment-summary.component';
import { CreateTaskComponent } from './task/create-task.component';
import { ApplicationConfigurationComponent } from "./application-configuration/applicationConfiguration.component";
import { ProviderManagementComponent } from "./provider-management/provider-management.component";
import { CorrespondenceComponent } from "./correspondence/correspondence.component";
import { AnnouncementsComponent } from "./Announcements/announcements.component";
import { ManualCorrespondenceComponent } from "./manual-correspondence/manual-correspondence.component";
import { AssessmentSummaryComponent } from './assessment-summary/assessment-summary.component';
import { SkillComponent } from './skill/skill.component';
import { CaseNotesSummaryComponent } from './case-notes-summary/case-notes-summary.component';
import { CaseNotesComponent } from './case-notes/case-notes.component';
import { ProviderDashboardComponent } from "./provider-dashboard/provider-dashboard.component";
import { AccessControlSummaryComponent } from './access-control-summary/access-control-summary.component';
import { AccessControlDetailsComponent } from './access-control-details/access-control-details.component';
import { EducationCertificationComponent } from './education-certification/education-certification.component';
import { EmploymentPlanSummaryComponent } from './employment-plan-summary/employment-plan-summary.component';
import { EmploymentPlanAuditComponent } from './employment-plan-audit/employment-plan-audit.component';
import { EmploymentPlanComponent } from './employment-plan/employment-plan.component';
import { ComponentDetailsComponent } from './component-details/component-details.component';
import { ReviewRecommendationComponent } from './review-recommendations/review-recommendations.component';
import { ComponentOverallProgressComponent } from './component-overall-progress/component-overall-progress.component';
import { ComponentSummaryComponent } from './component-summary/component-summary.component';
import { TrackComponentComponent } from './track-component/track-component.component';
import { ContactComponent } from "./contact/contact.component";
import { ServiceProviderComponent } from './service-provider/service-provider.component';
import { ContactHistoryComponent } from "./contact-history/contact-history.component";
import { ContactDetailsComponent } from "./contact-details/contact-details.component";
import { AnnouncementsSummaryComponent } from './announcements-summary/announcements-summary.component';
import { ReimbursementsSummaryComponent } from './reimbursements-summary/reimbursements-summary.component';
import { ReimbursementsComponent } from './reimbursements/reimbursements.component';
import { AdminProviderDetailsComponent } from './admin-provider-details/admin-provider-details.component';
import { AdminProviderSummaryComponent } from './admin-provider-summary/admin-provider-summary.component';
import { AdminProviderCountyComponent } from './admin-provider-county/admin-provider-county.component';
import { AdminProviderOfficeComponent } from './admin-provider-office/admin-provider-office.component';
import { WorkerDashboardComponent } from "./worker-dashboard/worker-dashboard.component";
import { StaffManagementSummaryComponent } from "./staff-management-summary/staff-management-summary.component";
import { StaffManagementComponent } from "./staff-management/staff-management.component";
import { AdminAnnouncementSummaryComponent } from "./admin-announcement-summary/admin-announcement-summary.component";
import { AdminAnnouncementDetailsComponent } from "./admin-announcement-details/admin-announcement-details.component";
import { CanDeactivateGuard } from "./shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TestScoreComponent } from './test-score/test-score.component';
import { BarriersComponent } from './barriers/barriers.component';
import { WorkHistoryComponent } from './work-history/work-history.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RefferalHistoryComponent } from './refferal-history/refferal-history.component';
import { TaskSummaryComponent } from './task-summary/task-summary.component';
import { LoginDhsComponent } from './login-dhs/login-dhs.component';
import { ErrorComponent } from './error/error.component';
import { ComparableWorkfareComponent } from './comparable-workfare/comparable-workfare.component';
import { UploadComponent } from './upload/upload.component';
import { EmploymentTrainingRetentionComponent } from './employment-training-retention/employment-training-retention.component';
import { MonthlySnapshotDetailsComponent } from './monthly-snapshot-details/monthly-snapshot-details.component';
import { MonthlySnapshotRollupComponent } from './monthly-snapshot-rollup/monthly-snapshot-rollup.component';
import { ComponentActivityReportComponent } from './component-activity-report/component-activity-report.component';
import { PotentialCandidatesReportComponent } from './potential-candidates-report/potential-candidates-report.component';
import { AriesTaskReportComponent } from './aries-task-report/aries-task-report.component';
import { FnsreportComponent } from './fnsreport/fnsreport.component';
import { Fnsreport2Component } from './fnsreport2/fnsreport2.component';
import { Fnsreport3Component } from './fnsreport3/fnsreport3.component';
import { Fnsreport4Component } from './fnsreport4/fnsreport4.component';
import { ProviderDeterminationComponent } from './provider-determination/provider-determination.component';
import { EnrollmentDetailComponent } from './enrollment-detail/enrollment-detail.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/SNAPWorks/workerportal',
    pathMatch: 'full'
  },
  {
    path: 'task/assessmentSummary/education',
    component: EducationCertificationComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/assessmentSummary/skill',
    component: SkillComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/assessmentSummary/test-score',
    component: TestScoreComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/assessmentSummary/barrier',
    component: BarriersComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: '404',
    component: ErrorComponent
  },
  {
    path: 'task/assessmentSummary/work-history',
    component: WorkHistoryComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'dashboard',
    component: DashboardComponent
  },
  {
    path: 'redirect',
    component: RedirectComponent
  },
  {
    path: 'dashboard/provider',
    component: ProviderDashboardComponent
  },
  {
    path: 'dashboard/worker',
    component: WorkerDashboardComponent
  },
  {
    path: 'task/correspondence',
    component: UploadComponent, 
  },{
    path: 'task/correspondence/notices',
    component: CorrespondenceComponent, 
  },
  {
    path: 'task',
    component: TaskComponent
  },
  {
    path: 'task/summary',
    component: TaskSummaryComponent
  },
  {
    path: 'task/summary/create',
    component: CreateTaskComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/contactSummary',
    component: ContactHistoryComponent
  },
  {
    path: 'task/contactSummary/contactDetails',
    component: ContactDetailsComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/personSummary/householdSummary',
    component: HouseholdSummaryComponent
  },
  {
    path: 'task/personSummary/employmentSummary',
    component: EmploymentSummaryComponent
  },
  {
    path: 'task/personSummary/eligibilitySummary',
    component: EligibilitySummaryComponent
  },
  {
    path: 'task/personSummary/enrollmentSummary',
    component: EnrollmentSummaryComponent
  },
  {
    path: 'task/appointment',
    component: AppointmentComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/appointment/history',
    component: AppointmentHistoryComponent
  },
  {
    path: 'task/createTask',
    component: CreateTaskComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'reports/report-summary',
    component: ReportSummaryComponent
  },
  {
    path: 'reports/fnsreport',
    component: FnsreportComponent
  },
  {
    path: 'reports/fnsreport2',
    component: Fnsreport2Component
  },
  {
    path: 'reports/fnsreport3',
    component: Fnsreport3Component
  },
  {
    path: 'reports/fnsreport4',
    component: Fnsreport4Component
  },
  {
    path: 'reports',
    component: ReportsComponent
  },
  {
    path: 'reports/employment-training-retention',
    component: EmploymentTrainingRetentionComponent
  },
  {
    path: 'reports/monthly-snapshot-details',
    component: MonthlySnapshotDetailsComponent
  },
  {
    path: 'reports/monthly-snapshot-rollup',
    component: MonthlySnapshotRollupComponent
  },
  {
    path: 'reports/component-activity',
    component: ComponentActivityReportComponent
  },
  {
    path: 'reports/aries-task',
    component: AriesTaskReportComponent
  },
  {
    path: 'reports/potential-candidates',
    component: PotentialCandidatesReportComponent
  },
  {
    path: 'admin',
    component: AdminComponent
  },
  {
    path: 'admin/applicationConfig',
    component: ApplicationConfigurationComponent
  },
  {
    path: 'admin/provider-management',
    component: AdminProviderSummaryComponent
  },
  {
    path: 'admin/provider-management/provider-details',
    component: AdminProviderDetailsComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/provider-management/provider-county',
    component: AdminProviderCountyComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/provider-management/provider-office',
    component: AdminProviderOfficeComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/staff-management',
    component: StaffManagementSummaryComponent
  },
  {
    path: 'admin/staff-management/details',
    component: StaffManagementComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'admin/announcementsSummary',
    component: AdminAnnouncementSummaryComponent
  },
  {
    path: 'admin/announcementsSummary/details',
    component: AdminAnnouncementDetailsComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/announcementsSummary/announcements',
    component: AnnouncementsComponent,
    canDeactivate: [CanDeactivateGuard]
  }, {
    path: 'task/announcementsSummary',
    component: AnnouncementsSummaryComponent
  },
  {
    path: 'admin/accesscontrol',
    component: AccessControlSummaryComponent
  },
  {
    path: 'admin/accesscontrol/details',
    component: AccessControlDetailsComponent
  },
  {
    path: 'reports/federalReports',
    component: FederalReportsComponent
  },
  {
    path: 'reports/federalReports/:report',
    component: FederalReportsComponent
  },
  {
    path: 'task/noncomplianceSummary/noncompliance',
    component: NonComplianceComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/noncomplianceSummary',
    component: NonComplianceSummaryComponent
  },
  {
    path: 'task/reimbursementsSummary/reimbursements',
    component: ReimbursementsComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/reimbursementsSummary',
    component: ReimbursementsSummaryComponent
  },
  {
    path: 'task/caseNotesSummary',
    component: CaseNotesSummaryComponent
  },
  {
    path: 'task/caseNotesSummary/caseNotes',
    component: CaseNotesComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/employmentPlanSummary',
    component: EmploymentPlanSummaryComponent
  },
  {
    path: 'task/employmentPlanSummary/employmentPlan',
    component: EmploymentPlanComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/refferalHistory',
    component: RefferalHistoryComponent
  },
  {
    path: 'task/personSummary',
    component: PersonInformationComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/componentSummary',
    component: ComponentSummaryComponent
  },
  {
    path: 'task/componentSummary/componentDetails',
    component: ComponentDetailsComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/componentSummary/reviewRecommendations',
    component: ReviewRecommendationComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/componentSummary/serviceProvider',
    component: ServiceProviderComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/componentSummary/trackComponent',
    component: TrackComponentComponent
  },
  {
    path: 'task/componentSummary/overallProgress',
    component: ComponentOverallProgressComponent
  },
  {
    path: 'task/componentSummary/comparable',
    component: ComparableWorkfareComponent
  },
  {
    path: 'task/assessmentSummary',
    component: AssessmentSummaryComponent
  },
  {
    path: 'task/assessmentSummary/provider-determination',
    component: ProviderDeterminationComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/personSummary/enrollmentDetail',
    component: EnrollmentDetailComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'task/paymentSummary',
    component: PaymentSummaryComponent
  },
  {
    path: 'task/requestPayment',
    component: RequestPaymentComponent
  },
  {
    path: 'task/paymentDetails',
    component: PaymentDetailsComponent
  },
  {
    path: 'task/:id/auditHistory',
    component: EmploymentPlanAuditComponent
  },
  {
    path: 'universe/:id/auditHistory',
    component: EmploymentPlanAuditComponent
  },
  {
    path: 'SNAPWorks/providerportal',
    component: LoginComponent,
    data: { navRequired: false, showHeaderControls: false }
  },
  {
    path: 'SNAPWorks/workerportal',
    component: LoginDhsComponent,
    data: { navRequired: false, showHeaderControls: false }
  },
  {
    path: 'universe/personSummary',
    component: PersonInformationComponent,
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'universe/personSummary/householdSummary',
    component: HouseholdSummaryComponent
  },
  {
    path: 'universe/personSummary/employmentSummary',
    component: EmploymentSummaryComponent
  },
  {
    path: 'universe/personSummary/eligibilitySummary',
    component: EligibilitySummaryComponent
  },
  {
    path: 'universe/personSummary/enrollmentSummary',
    component: EnrollmentSummaryComponent
  },
  {
    path: 'universe/create',
    component: CreateTaskComponent
  },
  {
    path: 'reset',
    component: ResetPasswordComponent

  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent

  },
  {
    path: '**',
    redirectTo: '/SNAPWorks/workerportal'
  }
];

//{onSameUrlNavigation:"reload"} allows reloading the component again on page refresh. Does not work in Angular 5.2 without Router Guard
@NgModule({
  imports: [RouterModule.forRoot(routes),
  RouterModule.forRoot(navbarRoute),
  RouterModule.forRoot(innerNavRoute)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts